import { Button, Icon } from "@platform/design-system";

interface AddRepButtonProps {
  onClick: () => void;
}

export const AddRepButton = ({
  onClick,
}: AddRepButtonProps): React.JSX.Element => (
  <Button
    data-testid="add-rep-button"
    variant="primary"
    size="sm"
    startIcon={<Icon name="add" />}
    onClick={onClick}
  >
    Add Rep
  </Button>
);
